import Vue from "vue";
import CxltToastr from "cxlt-vue2-toastr";

//Definition du toast
var toastrConfigs = {
  position: "top right",
  showDuration: 3000,
  progressBar: true,
  timeOut: 3000,
};
Vue.use(CxltToastr, toastrConfigs);
/**
 * Classe utils contenant les fonctions d'affichage du Toast
 */
const toastService = {
  /**
   * Les trois fonctions qui suivent permette d'afficher un toast d'un type,
   * ces fonction sont factoriser pour permettre de changer facilement de service de Toast
   */
  showErrorToast(toastObject) {
    Vue.prototype.$toast.error(toastObject);
  },
  showInfoToast(toastObject) {
    Vue.prototype.$toast.info(toastObject);
  },
  showSuccessToast(toastObject) {
    Vue.prototype.$toast.success(toastObject);
  },

  /**
   * Affiche un Toast d'erreur en fonction du statut de la réponse
   * si la reponse ne contient pas un attribut data.message
   * @param {httpResponse} response
   */
  displayResponseErrorToast(response) {
    const DEFAULT_MESSAGE = "Le serveur a retourné une erreur";
    //On prépare l'objet de création du Toast avec un message pas defaut
    let toastObject = {
      title: "Erreur",
      message: DEFAULT_MESSAGE,
    };
    if (response) {
      toastObject.message = response.data.message;
      //Si la reponse du serveur ne contient pas de message on en crée un en fonction du numéro status
      if (
        !toastObject.message ||
        toastObject.message == "No message available"
      ) {
        switch (response.status) {
          case 504:
            toastObject.message = "Impossible de joindre le serveur";
            break;
          case 404:
            toastObject.message = "Ressource non trouvée";
            break;

          default:
            toastObject.message = DEFAULT_MESSAGE;
            break;
        }
      }
    }
    toastService.showErrorToast(toastObject);
  },
  /**
   * Affiche un toast de succés
   * @param {string} message
   */
  displaySuccessToast(message) {
    let toastObject = {
      title: "Succés",
      message: message,
    };
    toastService.showSuccessToast(toastObject);
  },
  /**
   * Affiche un toast d'information
   * @param {string} message
   */
  displayInfoToast(message) {
    let toastObject = {
      title: "Information",
      message: message,
    };

    toastService.showInfoToast(toastObject);
  },
  /**
   * Affiche un toast d'erreur
   * @param {string} message
   */
  displayErrorToast(message) {
    let toastObject = {
      title: "Erreur",
      message: message,
    };
    toastService.showErrorToast(toastObject);
  },
};

export default toastService;
